import { StarFilled as StarIcon } from 'education-icons';
import React from 'react';

import { UI_KIT_TEXT_TYPOGRAPHY } from '../../constants';
import Text from '../../text/text';
import { b } from '../cn';
// @ts-ignore
import constants from '../showcase-lesson-card.scss';

interface Props {
    assignedCount?: number;
    rating?: number;
}

const RATING_STAR_WIDTH_IN_PIXELS = parseInt(constants.ratingStarWidth, 10);

export const ShowcaseLessonCardFooter = ({ assignedCount, rating }: Props) => {
    // если рейтинг задан и больше 3, то он приоритетнее текста
    const shouldShowRating = rating && rating >= 3;
    const shouldShowText = assignedCount && !shouldShowRating;

    if (!shouldShowRating && !shouldShowText) {
        return null;
    }

    if (shouldShowText) {
        return (
            <div className={b('footer')}>
                <Text
                    className={b('footer-text')}
                    id="showcaseRecommendationCard.assigned"
                    typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphLRegular}
                    values={{ number: assignedCount }}
                />
            </div>
        );
    }

    if (!rating) {
        return null;
    }

    const partStarIndex = Math.floor(rating);
    const partOfStar = rating - partStarIndex;

    const stars = new Array(5).fill(null).map((_, i) => {
        if (i < partStarIndex) {
            return <StarIcon className={b('rating-star', { filled: true })} key={i} />;
        } else if (i === partStarIndex) {
            return (
                <span className={b('rating-star-part-wrapper')} key={i}>
                    <StarIcon className={b('rating-star')} />
                    <span className={b('rating-star-part')} style={{ width: RATING_STAR_WIDTH_IN_PIXELS * partOfStar }}>
                        <StarIcon className={b('rating-star', { filled: true })} />
                    </span>
                </span>
            );
        }
        return <StarIcon className={b('rating-star')} key={i} />;
    });

    return (
        <div className={b('footer')}>
            <div className={b('footer-rating-stars')}>{stars}</div>
            <Text className={b('footer-rating-number')} typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphLRegular}>
                {Math.min(rating, 5)}
            </Text>
        </div>
    );
};
